export default "__VITE_ASSET__BR0W_wDB__"